import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../views/HomePage.vue'
import UserList from '../views/UserList.vue'
import Attendance from '../views/Attendance.vue'
import SeatMap from '../views/SeatMap.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/user-list',
    name: 'UserList',
    component: UserList
  },
  {
    path: '/attendance',
    name: 'Attendance',
    component: Attendance
  },
  {
    path: '/seat-map',
    name: 'SeatMap',
    component: SeatMap
  },
  // 可以根据需要添加其他路由
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router 